var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6644 3.65292H16.6728V0.154917C16.3263 0.10725 15.1346 0 13.7468 0C10.851 0 8.86738 1.82142 8.86738 5.16908V8.25H5.67188V12.1605H8.86738V22H12.7852V12.1614H15.8515L16.3382 8.25092H12.7843V5.55683C12.7852 4.42658 13.0895 3.65292 14.6644 3.65292Z",
    fill: "#273043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.459855ce1369c6bfe73e7eb2a97e60d1.svg";
export { ForwardRef as ReactComponent };